import { useEffect } from 'react';
import { Hero, SocialProof, Testimonials1, Problem } from './components/HeaderSections';
import { ProductTomos, Bonuses, UrgencyCounter, Pricing } from './components/CoreSections';
import { Testimonials2, Guarantee, FAQ, CostOfNotHaving, FinalCTA, Footer } from './components/FooterSections';
import { AnnouncementBar } from './components/AnnouncementBar';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
import { ExitIntentModal } from './components/ExitIntentModal';
import { MetaPixel, PRODUCTS } from './components/MetaPixel';
import { prefetchPage, whenIdle } from './utils/prefetch';
const HERO_MOCKUP = 'https://cdn.magicpatterns.com/uploads/bGFnoJ26mLpq5ytiyGic7n/Mockup_principal.png';
const CHECKOUT_ORIGIN = 'https://functionele-training-365.impultienda.ar';

// Helper: ensure a <meta> tag with given attributes exists in <head>
const ensureMeta = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = Object.entries(attrs).filter(([k]) => k !== 'content').map(([k, v]) => `[${k}="${v}"]`).join('');
  let meta = document.head.querySelector<HTMLMetaElement>(`meta${selector}`);
  if (!meta) {
    meta = document.createElement('meta');
    document.head.appendChild(meta);
  }
  Object.entries(attrs).forEach(([k, v]) => meta!.setAttribute(k, v));
};
// Helper: ensure a <link> tag exists in <head>
const ensureLink = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = `link[rel="${attrs.rel}"][href="${attrs.href}"]`;
  if (document.head.querySelector(selector)) return;
  const link = document.createElement('link');
  Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
  document.head.appendChild(link);
};
export function App() {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    // Dutch page for the Netherlands.
    document.documentElement.lang = 'nl';
    document.documentElement.removeAttribute('translate');
    document.documentElement.classList.remove('notranslate');
    document.head.querySelectorAll('meta[name="google"][content="notranslate"]').forEach(m => m.remove());
    document.title = 'Functionele Training 365™ — Je hele jaar aan functionele lessen, kant-en-klaar';
    ensureMeta({
      'http-equiv': 'content-language',
      content: 'nl'
    });
    ensureMeta({
      name: 'language',
      content: 'Dutch'
    });
    ensureMeta({
      name: 'description',
      content: 'Functionele Training 365: 6 delen, 365 kant-en-klare sessies en 5 strategische bonussen. Je hele jaar aan functionele lessen, vandaag klaar voor €19. Veilig betalen, geen verborgen kosten.'
    });
    ensureMeta({
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, viewport-fit=cover'
    });
    ensureMeta({
      name: 'theme-color',
      content: '#020617'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.googleapis.com'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossorigin: ''
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://cdn.magicpatterns.com'
    });
    ensureLink({
      rel: 'preload',
      as: 'image',
      href: HERO_MOCKUP,
      fetchpriority: 'high'
    });
    // Warm up the checkout connection so CTA clicks navigate instantly.
    ensureLink({
      rel: 'dns-prefetch',
      href: CHECKOUT_ORIGIN
    });
    ensureLink({
      rel: 'preconnect',
      href: CHECKOUT_ORIGIN,
      crossorigin: ''
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://connect.facebook.net'
    });
    // Once the page is idle, fetch the checkout in the background so the
    // buy buttons open it instantly.
    whenIdle(() => prefetchPage(PRODUCTS.ft365.checkoutUrl), 4000);
  }, []);
  return <div lang="nl" className="min-h-screen w-full bg-slate-950 text-slate-300 selection:bg-blue-600 selection:text-white" data-id="element-0" data-mp="6nw805kguvh9">
      <MetaPixel data-id="element-1" data-mp="arkd8hlmlezc" />
      <SocialProofPopup data-id="element-2" data-mp="anwl9mvtx0mq" />
      <ExitIntentModal data-id="element-3" data-mp="qwvpk8lpwd3q" />
      <AnnouncementBar data-id="element-4" data-mp="qxfazzaktjmi" />
      <main data-id="element-5" data-mp="qyq9pkp6016r">
        <Hero data-id="element-6" data-mp="qygn873bwc5t" />
        <SocialProof data-id="element-7" data-mp="qyyr9pw8fuoa" />
        <Testimonials1 data-id="element-8" data-mp="m5x6j19ch0ws" />
        <Problem data-id="element-9" data-mp="m5dxka1o9muw" />
        <ProductTomos data-id="element-10" data-mp="m4uj53b8dglm" />
        <Bonuses data-id="element-11" data-mp="m4m2r1fwft5o" />
        <UrgencyCounter data-id="element-12" data-mp="h72qg72rhqgd" />
        <Pricing data-id="element-13" data-mp="h6khqaywxjrk" />
        <Testimonials2 data-id="element-14" data-mp="h83ys3se7yue" />
        <Guarantee data-id="element-15" data-mp="h59j0pkbr27b" />
        <FAQ data-id="element-16" data-mp="c89dcfre01gq" />
        <CostOfNotHaving data-id="element-17" data-mp="c8rfft0qd9wk" />
        <FinalCTA data-id="element-18" data-mp="c9kee7tg6v45" />
      </main>
      <Footer data-id="element-19" data-mp="c66c0zksalwp" />
      <StickyMobileCTA data-id="element-20" data-mp="19vzvv9lvjsrp" />
    </div>;
}